// Bandeau d'une analyse TURPE non concluante / non vérifiée (règle du 24/10/2026) : motif
// affiché ; ni montant, ni recommandation, ni rapport client tant qu'elle ne l'est pas.
import React from 'react';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';
import { motifConclusion } from '../../utils/resumeTurpe';

export default function BandeauConclusionTurpe({ resume, className = '', onRelancer = null, enCours = false }) {
  const m = motifConclusion(resume);
  if (!m) return null;
  return (
    <div role="alert" data-testid="turpe-non-concluant" className={`flex items-start gap-2 border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-900 rounded ${className}`}>
      <FiAlertTriangle className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" aria-hidden />
      <div>
        <p className="font-semibold">{m.titre} : pas de montant, pas de recommandation de puissance ni de version, pas de rapport client.</p>
        {m.motifs.map((t) => <p key={t}>{t}</p>)}
      </div>
      {onRelancer && (
        <button
          type="button"
          onClick={onRelancer}
          disabled={enCours}
          data-testid="turpe-relancer"
          title="Recalcule tout : analyse de base (et son verdict), puissances, version d'utilisation ; efface les résultats et le choix final antérieurs."
          className="ml-auto self-center inline-flex items-center gap-1 px-2.5 py-1 rounded bg-amber-600 text-white text-[11px] font-semibold hover:bg-amber-700 disabled:opacity-50 whitespace-nowrap"
        >
          <FiRefreshCw className={`h-3.5 w-3.5 ${enCours ? 'animate-spin' : ''}`} />
          {enCours ? 'Relance en cours…' : "Relancer l'analyse"}
        </button>
      )}
    </div>
  );
}
